import React, {Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import BrandingConfigForm from "../BrandingConfigForm/BrandingConfigForm";
import {createBrandingConfig} from '../../../actions/actionBranding';

class CreateBrandingConfig extends Component {
    constructor (props){
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div >
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Branding Config</strong>
                                </CardHeader>
                                <BrandingConfigForm
                                    createBrandingConfig={this.props.createBrandingConfig}/>
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}


export default connect(state =>
        ({
            branding_configs: state.branding.branding_configs || [],
        }),
dispatch =>
    ({
        createBrandingConfig: (data) => dispatch(createBrandingConfig(data))
    }))(CreateBrandingConfig);




// WEBPACK FOOTER //
// ./src/views/Branding/CreateBrandingConfig/CreateBrandingConfig.js